import { Box } from "@mui/material"
import React from "react"
import { useUpdateStatusHook } from "../../entities/job/helper"
import { useJobContext } from "../../contexts/JobContext"
import JobItemList from "./JobItemList"
import { EJobStatus, ICustomFieldTemplate, IJob, IJobItems } from "../../entities/job/interface"

interface ILoadingJobProps {
    updateJobStatus: (status: EJobStatus) => void
    jobStatus: EJobStatus
    stage: string
}

//to be put in job component
const Processing: React.FC<ILoadingJobProps> = ({ updateJobStatus, stage }) => {
    const { currentJobs } = useJobContext()

    const { handleJobUpdate, jobUpdateMutationLoading } = useUpdateStatusHook()

    const handleJobProcessing = async (job: IJob, items: IJobItems[], customFields: ICustomFieldTemplate[]) => {
        try {
            const requiredCustomFields = customFields.map((field: ICustomFieldTemplate) => ({
                customFieldGroupId: field.customFieldGroup?._id,
                customFieldTemplateId: field.customFieldTemplateId,
                value: field.value,
            }))

            const payload = {
                items: items?.map((item: IJobItems) => ({
                    itemId: item.itemId,
                    quantityLoaded: item?.quantityLoaded,
                    quantityUnloaded: item?.quantityUnloaded,
                    quantity: item?.quantity,
                    pricePerItem: item?.pricePerItem,
                })),
                customFields: requiredCustomFields,
            }
            if (!job.isJobCompleted) {
                await handleJobUpdate(payload, job._id)
            }
        } catch (error) {
            console.error(error)
        }
    }
    return (
        <>
            <Box
                width={"90%"}
                maxWidth={700}
                display="flex"
                flexDirection="column"
                height={"80vh"}
                paddingTop={"3%"}
                bgcolor={"primary.main"}
                position={"absolute"}
                borderRadius={6}
                justifyContent={"space-between"}
                bottom={100}
                marginBottom={3}
            >
                <JobItemList
                    currentJobs={currentJobs}
                    handleJobUpdate={handleJobProcessing}
                    jobStatusMutationLoading={jobUpdateMutationLoading}
                    updateJobStatus={updateJobStatus}
                    stage={stage}
                />
            </Box>
        </>
    )
}

export default Processing
